<template>
  <nav :class="style.navLayout">
    <div :class="style.links">
      <template v-for="item in navList">
        <ActionMenu
          v-if="isQuizItem(item)"
          :modelValue="isQuizPopupOpen"
          :actions="quizActions"
          placement="right-start"
          :offset="24"
          :width="228"
          @update:modelValue="setQuizPopupValue"
        >
          <template #trigger="{isOpen, toggle}">
            <TooltipComponent position="right" :text="item.text">
              <TabStyle
                :active="isOpen || isActive(item?.value as string)"
                :icon="item.icon"
                @click.stop="toggle"
              />
            </TooltipComponent>
          </template>
        </ActionMenu>

        <TooltipComponent position="right" :text="item.text" v-else>
          <TabStyle
            :active="isActive(item?.value as string)"
            :icon="item.icon"
            @click.stop="item.handler"
          />
        </TooltipComponent>
      </template>
    </div>

    <ActionMenu
      :modelValue="isAccountPopupOpen"
      :actions="accountActions"
      placement="right-start"
      :offset="8"
      :width="188"
      :popupStyle="accountPopupStyle"
      @update:modelValue="setAccountPopupValue"
    >
      <template #trigger="{toggle}">
        <TooltipComponent position="right" :text="userName">
          <TabUserAvatar
            :text="userFirstLetter"
            :active="isGlow"
            @click.stop="toggle"
          />
        </TooltipComponent>
      </template>
    </ActionMenu>
  </nav>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "../NavLayoutNew.module.scss";

import ActionMenu from "@/elements/UI/popup/ActionMenu/ActionMenu.vue";
import TabUserAvatar from "@/elements/UI/tabs/TabUserAvatar/TabUserAvatar.vue";
import TabStyle from "@/elements/UI/tabs/TabStyle/TabStyle.vue";
import TooltipComponent from "@/elements/UI/overlay/Tooltip/TooltipComponent.vue";

export default defineComponent({
  name: "NavPrimaryPart",

  components: {
    TooltipComponent,
    TabStyle,
    TabUserAvatar,
    ActionMenu
  },

  emits: ["toggle-account-popup", "toggle-quiz-popup"],

  props: {
    navList: {
      type: Array as PropType<ListActionItem[]>,
      required: true
    },

    accountActions: {
      type: Array as PropType<ListActionItem[]>,
      required: true
    },

    quizActions: {
      type: Array as PropType<ListActionItem[]>,
      required: true
    },

    isAccountPopupOpen: {
      type: Boolean,
      required: true
    },

    isQuizPopupOpen: {
      type: Boolean,
      required: true
    },

    isGlow: {
      type: Boolean,
      required: true
    },

    activeGroup: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    userFirstLetter(): string {
      return this.userName?.[0] ?? "U";
    },

    userName(): string {
      return this.$userStore.getUser?.name;
    },

    accountPopupStyle(): Record<string, string | number> {
      return {
        position: "fixed",
        top: "auto",
        left: "84px",
        bottom: "12px"
      };
    }
  },

  methods: {
    isActive(group: string): boolean {
      if (group === "quiz") {
        return [
          "landingPage",
          "configuration",
          "ABTest",
          "analytics",
          "setting",
          "settingDoctors",
          "settingServices",
          "quiz"
        ].includes(this.activeGroup);
      }

      if (group === "settingApplication") {
        return this.activeGroup === "settingApplication";
      }

      return this.activeGroup === group;
    },

    isQuizItem(item: ListActionItem): boolean {
      return item.value === "quiz";
    },

    setQuizPopupValue(value: boolean): void {
      if (value !== this.isQuizPopupOpen) {
        this.$emit("toggle-quiz-popup");
      }
    },

    setAccountPopupValue(value: boolean): void {
      if (value !== this.isAccountPopupOpen) {
        this.$emit("toggle-account-popup");
      }
    }
  }
});
</script>
